import { render } from "./SuccessfulModal.vue?vue&type=template&id=a6dbd5a2&scoped=true"
import script from "./SuccessfulModal.vue?vue&type=script&lang=js"
export * from "./SuccessfulModal.vue?vue&type=script&lang=js"

import "./SuccessfulModal.vue?vue&type=style&index=0&id=a6dbd5a2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6dbd5a2"]])

export default __exports__